import { ImageKinds } from ".";

export class DocumentImageUpdateInformation {
  itemSetId: number;
  privateId: number;
  sourceDocumentId: number;
  sourceImageKey: string;
  imageKind: ImageKinds;
  claioImageId: string;
  imageDepartmentId: string;
  rotationAngle: number;
  externalImageId: string;
  isCache: boolean;
  quotedFormatId?: number;  // Format画像の場合に指定する.
  originalSourceImageKey: string;
  isOriginalSourceCache: boolean;
}
